/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuAvatar } from '@neutron/react';

export const AvatarContainer = styled(NeuAvatar)`
  margin-right: 0.5rem;
`;

export const EmployeeInfoContainer = styled.div`
  display: flex;
`;

export const EmployeeAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const StartDateContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  position: relative;
`;
